import { useState, useEffect } from 'react';
import { api } from '../services/apiService';
// import { useAuth } from '../context/AuthContext'; // Reserved for future authentication

const PopupForm = ({ popup, onClose, onSave }) => {
  // const { admin } = useAuth(); // Reserved for future authentication
  const [formData, setFormData] = useState({
    title: '',
    link: '',
    isActive: true,
    endDate: ''
  });
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (popup) {
      setFormData({
        title: popup.title,
        link: popup.link,
        isActive: popup.isActive,
        endDate: popup.endDate ? new Date(popup.endDate).toISOString().split('T')[0] : ''
      });
    }
  }, [popup]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
      formDataToSend.append('link', formData.link);
      formDataToSend.append('isActive', formData.isActive);
      if (formData.endDate) formDataToSend.append('endDate', formData.endDate);
      if (image) formDataToSend.append('image', image);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
        }
      };

      const url = popup 
        ? `/api/popups/${popup._id}`
        : '/api/popups';

      const method = popup ? 'put' : 'post';
      await api[method](url, formDataToSend, config);

      onSave();
      onClose();
    } catch (err) {
      console.error('Full error:', err);
      if (err.response?.status === 401) {
        setError('Session expired. Please login again.');
      } else {
        setError(err.response?.data?.error || err.message || 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && <div className="text-red-500 p-2 mb-4 rounded bg-red-50">{error}</div>}
      
      {popup && popup.image && (
        <div>
          <label className="block text-sm font-medium text-gray-700">Current Image</label>
          <img 
            src={`data:image/jpeg;base64,${popup.image}`} 
            alt="Current popup" 
            className="mt-2 h-32 object-cover rounded"
          />
        </div>
      )}
      
      <div>
        <label className="block text-sm font-medium text-gray-700">Image *</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-[#166534] file:text-white hover:file:bg-[#0e3d1f]"
          required={!popup}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Title *</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#166534] focus:border-[#166534]"
          required
          placeholder="Enter popup title"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Link *</label>
        <input
          type="url"
          name="link"
          value={formData.link}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#166534] focus:border-[#166534]"
          required
          placeholder="https://example.com"
        />
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          name="isActive"
          checked={formData.isActive}
          onChange={handleChange}
          className="h-4 w-4 text-[#166534] focus:ring-[#166534] border-gray-300 rounded"
        />
        <label className="ml-2 block text-sm text-gray-700">Active (will deactivate any other active popup)</label>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">End Date (optional)</label>
        <input
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#166534] focus:border-[#166534]"
        />
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#166534]"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#166534] hover:bg-[#0e3d1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#166534] disabled:opacity-50"
        >
          {isLoading ? 'Saving...' : popup ? 'Update Popup' : 'Create Popup'}
        </button>
      </div>
    </form>
  );
};

export default PopupForm;